import { z } from "zod";
export var theCompositeModelSchema = z.object({
    name: z.string()
});
//# sourceMappingURL=TheCompositeModel.zod.js.map